module.exports = __webpack_public_path__ + "static/img/k16_8.d86ee1d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/k16_8.png
// module id = 7sCT
// module chunks = 0